
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import BtnCheck from "@/components/scope/btn-check.vue";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import ExpandControl from "@/components/scope/expand-control.vue";
import { verifyMoney } from "@common/src/utils/verify";
import { addCurrencyUnit, permitCountry } from "@common/src/utils/tools";
import t from "@common/src/i18n/t";
import SmsVerification from "@/components/scope/sms-verification/index.vue";
import TextTips from "@common/src/components/scope/text-tips/index.vue";

const service = namespace("service");
const app = namespace("app");
const base = namespace("base");
const marketing = namespace("marketing");
const setting = namespace("setting");
const finance = namespace("finance");
const inventory = namespace("inventory");

@Component({
  components: { BtnCheck, ExpandControl, SmsVerification, TextTips }
})
export default class Cashier extends Vue {
  @service.Action getOrderDetail;
  @service.Action orderPayment;
  @base.Action getDictionaryList;
  @marketing.Action queryCustomerCard;
  @setting.Action getPatternPaymentList;
  @inventory.Action queryInventoryAndNotice;
  @app.Mutation setPBPX;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @finance.Action getCustomerUnpaidOrder;
  @finance.Mutation setOnAccountManageRow;
  @finance.Action calcCustomerOrder;
  @finance.Action queryOtherDiscountCheckResult;
  @finance.Action sendOtherDiscountValidationCode;
  @app.State appType;
  @finance.Action queryDeferredCycleList;
  @finance.Action queryCustomerDeferredPayment;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  permitCountry = permitCountry;
  useableCouponList = []; // 可用优惠券列表
  balance = null;
  get breadData() {
    return this.onAccountTo === "true"
      ? [{ name: t("finance.payment-management"), path: "/finance/on-account-manage" }, { name: t("service.cashier") }]
      : [{ name: t("test.service-management"), path: "/service/index" }, { name: t("service.cashier") }];
  }
  get orderId() {
    return this.$route.params.id;
  }
  get onAccountTo() {
    return this.$route.params.onAccountTo;
  }
  showCardCheck: boolean = false;
  remark: string = "";
  subtractDiscounts = {
    isUse: false,
    disCountsValue: ""
  };
  isMerge: boolean = false;
  packageDiscounts = {
    // 套餐卡优惠
    isUse: false,
    disCountsValue: 0
  };
  unpaidOrderList: any = [];
  showDetailOrder: boolean = false;
  checkCoupon = {
    // 优惠券
    isUse: false,
    disCountsValue: "0"
  };
  handleExpandOrder() {
    this.showDetailOrder = !this.showDetailOrder;
  }
  handlePayWayChange(value, payment) {
    if (value) {
      let selectedAmount = 0;
      try {
        selectedAmount = this.paymentWayList.reduce((pre, cur) => {
          if (cur.isUse) {
            return pre + Number(cur.paidAmount);
          } else {
            return pre;
          }
        }, 0);
      } catch (e) {
        this.$message.error(t("service.incorrect-amount-input"));
      }
      if (Object.is(NaN, selectedAmount)) {
        return this.$message.error(t("service.incorrect-amount-input"));
      }
      console.log("[ payment ]", payment);
      if (payment.payMethodCode === "6") {
        if (this.balance > (this.totalOrderAmount - this.totalDiscount - selectedAmount).toFixed(2)) {
          payment.paidAmount = (this.totalOrderAmount - this.totalDiscount - selectedAmount).toFixed(2);
        } else {
          payment.paidAmount = this.balance;
        }
      } else {
        payment.paidAmount = (this.totalOrderAmount - this.totalDiscount - selectedAmount).toFixed(2);
      }
    } else {
      payment.paidAmount = 0;
    }
  }
  groupServiceQuantityMap: any = {};
  groupServiceQuantityMapCopy: any = {};
  groupPartsQuantityMap: any = {};
  groupPartsQuantityMapCopy: any = {};
  computeGroupServiceNum() {
    this.groupServiceQuantityMap = {};
    this.groupPartsQuantityMap = {};
    this.totalServiceList.forEach(service => {
      if (this.groupServiceQuantityMap[service.serviceCode]) {
        this.groupServiceQuantityMap[service.serviceCode] =
          this.groupServiceQuantityMap[service.serviceCode] + Number(service.quantity);
      } else {
        this.groupServiceQuantityMap[service.serviceCode] = Number(service.quantity);
      }
    });
    this.totalPartsList.forEach(parts => {
      if (!parts.isGroup) {
        if (this.groupPartsQuantityMap[parts.partsCode]) {
          this.groupPartsQuantityMap[parts.partsCode] =
            this.groupPartsQuantityMap[parts.partsCode] + Number(parts.quantity);
        } else {
          this.groupPartsQuantityMap[parts.partsCode] = Number(parts.quantity);
        }
      }
    });
    this.groupServiceQuantityMapCopy = Object.assign({}, this.groupServiceQuantityMap);
    this.groupPartsQuantityMapCopy = Object.assign({}, this.groupPartsQuantityMap);
  }
  handleLinkOpenCard() {
    const { href } = this.$router.resolve(`/marketing/card-open?customerCode=${this.detailData.customerCode}`);
    window.open(href);
  }
  handleCardUse(val) {
    if (!val) {
      this.cancelAllCardUesd();
    } else {
      if (!this.useableCardList || this.useableCardList.length < 1) {
        this.packageDiscounts.isUse = false;
        return this.$message.error(t("v212.currently-no-package-card-is-available"));
      }
      // 使用套餐卡，清空所有优惠券的东西
      this.computedCardDeduction();
    }
    // 清空支付方式
    this.resetPaymentInput();
  }
  paymentWayList: any = [];
  getPaymentList() {
    return this.getPatternPaymentList({
      status: "1",
      scene: "10"
    }).then(data => {
      this.paymentWayList = data.data.map(item => {
        item.isUse = false;
        item.paidAmount = 0;
        item.paidMethod = item.payMethodCode;
        item.billingCycle = "";
        return item;
      });
    });
  }
  // 更新所有服务/零配件 剩余可抵扣的数量
  updateAllCardDeductionNum() {
    this.groupServiceQuantityMap = Object.assign({}, this.groupServiceQuantityMapCopy);
    this.groupPartsQuantityMap = Object.assign({}, this.groupPartsQuantityMapCopy);
    this.useableCardList.forEach(card => {
      let cardIsSelected = false;
      card.serviceList &&
        card.serviceList.forEach(service => {
          if (service.checked && service.useNum > 0) {
            cardIsSelected = true;
            this.groupServiceQuantityMap[service.serviceCode] -= service.useNum;
          }
        });
      card.partsList &&
        card.partsList.forEach(parts => {
          if (parts.checked && parts.useNum > 0) {
            cardIsSelected = true;
            this.groupPartsQuantityMap[parts.partsCode] = Number(
              (this.groupPartsQuantityMap[parts.partsCode] - parts.useNum).toFixed(1)
            );
          }
        });
      if (cardIsSelected) {
        this.$set(card, "cardSelected", true);
      } else {
        card.cardSelected = false;
      }
    });
    this.cancelUseCoupon();
    this.calculateOrder();
    this.computedCardDeduction();
  }
  get totalServiceList() {
    if (this.isMerge) {
      const temp = [];
      this.unpaidOrderList.map(item => {
        if (item.serviceDetail && item.serviceDetail.length > 0) {
          temp.push(...item.serviceDetail);
        }
      });
      return temp;
    } else {
      if (this.detailData.serviceDetail && this.detailData.serviceDetail.length > 0) {
        return [].concat(this.detailData.serviceDetail);
      }
    }
    return [];
  }
  get totalPartsList() {
    if (this.isMerge) {
      const temp = [];
      this.unpaidOrderList.map(item => {
        if (item.partsDetail && item.partsDetail.length > 0) {
          temp.push(...item.partsDetail);
        }
      });
      return temp.filter(parts => parts.partsCode);
    } else {
      if (this.detailData.partsDetail && this.detailData.partsDetail.length > 0) {
        return [].concat(this.detailData.partsDetail).filter(parts => parts.partsCode);
      }
    }
    return [];
  }
  get additionalList() {
    const currentAdditional = this.detailData.additionalFees
      ? [
          {
            additionalFees: this.detailData.additionalFees,
            remark: this.detailData.additionalFeesRemark
          }
        ]
      : [];
    const allAdditional = [];
    this.unpaidOrderList.forEach(item => {
      if (item.additionalFees) {
        allAdditional.push({
          additionalFees: item.additionalFees,
          remark: item.additionalFeesRemark
        });
      }
    });
    return this.isMerge ? [].concat(allAdditional) : currentAdditional;
  }
  created() {
    this.init();
    this.setPBPX(100);
    if (this.$route.params.row) {
      this.setOnAccountManageRow(this.$route.params.row);
    }
  }
  cardDeductionTotal: number = 0;
  get accountOrderList() {
    return this.$route.params.orderList;
  }
  get totalDiscount() {
    // 优惠券和套餐卡只能存在一个
    return Number(
      (
        Number(this.subtractDiscounts.disCountsValue) +
        Number(this.checkCoupon.disCountsValue) +
        Number(this.packageDiscounts.disCountsValue)
      ).toFixed(2)
    );
  }
  get actuallyAmount() {
    return (this.totalOrderAmount - this.totalDiscount).toFixed(2);
  }
  cancelAllCardUesd() {
    this.useableCardList.forEach(card => {
      card.serviceList &&
        card.serviceList.forEach(service => {
          service.checked = false;
        });
      card.partsList &&
        card.partsList.forEach(parts => {
          parts.checked = false;
        });
    });
    this.packageDiscounts.isUse = false;
    this.updateAllCardDeductionNum();
  }
  computedCardDeduction() {
    let allCardDiscountAmount = 0;
    const cardList = this.useableCardList;
    cardList.forEach(card => {
      let discountAmount = 0;
      let cardIsSelected = false;
      card.serviceList &&
        card.serviceList.forEach(service => {
          if (service.checked && service.useNum > 0) {
            cardIsSelected = true;
            discountAmount += Number((service.useNum * Number(this.servicePriceMap[service.serviceCode])).toFixed(2));
          }
        }, 0);
      card.partsList &&
        card.partsList.forEach(parts => {
          if (parts.checked && parts.useNum > 0) {
            cardIsSelected = true;
            discountAmount += Number((parts.useNum * Number(this.partsPriceMap[parts.partsCode])).toFixed(2));
          }
        }, 0);
      if (cardIsSelected) {
        this.$set(card, "cardSelected", true);
      } else {
        card.cardSelected = false;
      }
      if (card.discountAmount) {
        card.discountAmount = discountAmount;
      } else {
        this.$set(card, "discountAmount", discountAmount);
      }
      allCardDiscountAmount += card.discountAmount;
    });
    if (!this.packageDiscounts.isUse) {
      this.cardDeductionTotal = 0;
    } else {
      this.cardDeductionTotal = allCardDiscountAmount;
    }
  }
  detailData: any = {};
  checkCodeData: any = {
    paymentCode: ""
  };
  checkCodeDataRules = {
    paymentCode: [
      {
        required: true,
        message: t("setting.select-project-type"),
        trigger: "blur"
      }
    ]
  };
  groupIndex: number = 1;
  onAccountOrderList = [];
  conponNeedData = undefined;
  couponData = [];
  counter: number = 0;
  cardAndCouponLoaded() {
    if (this.counter === 2) {
      if (this.useableCardList.length > 0 && this.useableCouponList.length === 0) {
        this.packageDiscounts.isUse = true;
      }
      if (this.useableCouponList.length > 0 && this.useableCardList.length === 0) {
        this.checkCoupon.isUse = true;
      }
      this.counter = 0;
    }
  }
  async init() {
    await this.getPaymentList();
    const orderData = await this.getOrderDetail({
      orderNo: this.orderId
    });
    this.getCycleList();
    this.detailData = orderData.data;
    this.getCustomerDeferredData();
    this.queryValueCardTotalBalance(); // 查询储值余额
    this.calculateOrder();
    this.addGroupFlag(this.detailData);
    this.groupIndex = 1; // 当前订单添加完套餐编号项目，下标置为1 给合并订单用
    if (this.detailData.customerCode) {
      if (this.onAccountTo === "true") {
        if (this.accountOrderList && this.accountOrderList.length !== 0) {
          this.unpaidOrderList = this.accountOrderList;
          this.unpaidOrderList.forEach(order => {
            this.addGroupFlag(order);
          });
          this.handleMergePay();
        } else {
          const onAccountList = await this.getCustomerUnpaidOrder({
            customerCode: this.detailData.customerCode,
            settlementStatus: 2
          });
          // 名下有多少个挂账

          this.unpaidOrderList = onAccountList.data;
          this.unpaidOrderList.forEach(order => {
            this.addGroupFlag(order);
          });
          this.handleMergePay();
        }
      } else {
        const unpaidList = await this.getCustomerUnpaidOrder({
          customerCode: this.detailData.customerCode
        });
        // 名下有多少个未付款

        this.unpaidOrderList = unpaidList.data;
        this.unpaidOrderList.forEach(order => {
          this.addGroupFlag(order);
        });
      }
    }
    this.computeGroupServiceNum();
  }
  handleMergePay() {
    // 清空支付方式
    this.resetPaymentInput();
    this.groupIndex = 1;
    this.isMerge = true;
    this.showDetailOrder = true;
    this.computeGroupServiceNum();
    this.cancelUseCoupon();
    this.cancelAllCardUesd();
    this.calculateOrder();
  }
  handleCancelMergePay() {
    // 清空支付方式
    this.resetPaymentInput();
    this.groupIndex = 1;
    this.isMerge = false;
    this.computeGroupServiceNum();
    this.cancelUseCoupon();
    this.cancelAllCardUesd();
    this.calculateOrder();
  }
  useableCardList: any = [];
  formatPriceValue() {
    this.subtractDiscounts.disCountsValue =
      this.subtractDiscounts.disCountsValue && Number(this.subtractDiscounts.disCountsValue).toFixed(2);
    // 清空支付方式
    this.resetPaymentInput();
  }
  handleUseCardChange(card, item) {
    // 清空支付方式
    this.resetPaymentInput();
    if (item.checked) {
      this.cancelSubtractDiscount();
      if (item.isParts) {
        if (item.residueCount >= this.groupPartsQuantityMap[item.partsCode]) {
          item.useNum = this.groupPartsQuantityMap[item.partsCode];
        } else {
          item.useNum = item.residueCount;
        }
      } else {
        if (item.residueCount >= this.groupServiceQuantityMap[item.serviceCode]) {
          item.useNum = this.groupServiceQuantityMap[item.serviceCode];
        } else {
          item.useNum = item.residueCount;
        }
      }
    } else {
      item.useNum = 0;
    }
    // 更新所有
    this.updateAllCardDeductionNum();
  }
  resetPaymentInput() {
    this.paymentWayList.forEach(item => {
      item.isUse = false;
      item.paidAmount = 0;
    });
  }
  handleUseNumChange() {
    this.updateAllCardDeductionNum();
  }
  partsPriceMap: any = {};
  servicePriceMap: any = {};
  addGroupFlag(orderData) {
    const serviceCodeMap = {}; // 存放service和parts索引映射关系
    orderData.partsDetail.forEach((parts, index) => {
      if (!this.partsPriceMap[parts.partsCode]) {
        this.partsPriceMap[parts.partsCode] = parts.sellingPrice;
      }
      if (parts.serviceCode) {
        parts.amount = 0; // 套餐零配件，不计入订单金额
        if (serviceCodeMap[parts.serviceCode]) {
          serviceCodeMap[parts.serviceCode].push(index);
        } else {
          serviceCodeMap[parts.serviceCode] = [index];
        }
      }
    });
    orderData.serviceDetail.forEach(serviceItem => {
      if (!this.servicePriceMap[serviceItem.serviceCode]) {
        this.servicePriceMap[serviceItem.serviceCode] = serviceItem.serviceFee;
      }
      if (serviceCodeMap[serviceItem.serviceCode]) {
        serviceItem.isGroup = true;
        serviceItem.groupServiceIndex = this.groupIndex;
        serviceCodeMap[serviceItem.serviceCode].forEach(i => {
          orderData.partsDetail[i].isGroup = true;
          orderData.partsDetail[i].groupServiceIndex = this.groupIndex;
        });
        this.groupIndex++;
      }
    });
  }
  // 检查金额输入格式
  checkAmount() {
    if (this.subtractDiscounts.isUse) {
      if (Number(this.subtractDiscounts.disCountsValue) < 0) {
        return {
          check: false,
          msg: t("v210831.other-offers-cannot-less-than-0")
        };
      }
    }
    let payAmount = this.paymentWayList.reduce((preV, curV) => {
      return preV + (curV.isUse ? Number(curV.paidAmount) : 0);
    }, 0);

    if (typeof payAmount === "number") {
      payAmount = Number(payAmount.toFixed(2));
    }
    if (this.totalOrderAmount < this.totalDiscount) {
      return {
        check: false,
        msg: t("service.total-discount-cannot")
      };
    }
    const actuallyAmount = Number(this.actuallyAmount);
    console.log(55, payAmount, actuallyAmount);
    if (payAmount > actuallyAmount) {
      return {
        check: false,
        msg: t("service.payment-amount-must-not-greater")
      };
    } else if (payAmount < actuallyAmount) {
      return {
        check: false,
        msg: t("service.payment-amount-must-not-be-less")
      };
    } else if (payAmount === actuallyAmount) {
      let checkObj = {
        check: true,
        msg: null
      };
      this.paymentWayList.forEach(item => {
        if (item.paidAmount) {
          if (verifyMoney(item.paidAmount)) {
            checkObj = {
              check: true,
              msg: null
            };
          } else {
            checkObj = {
              check: false,
              msg: t("v210831.please-enter-positive-integer-or-float-amount")
            };
            return;
          }
        }
        if (item.payMethodCode === "6") {
          if (item.paidAmount <= this.balance) {
            checkObj = {
              check: true,
              msg: null
            };
          } else {
            checkObj = {
              check: false,
              msg: t("v210831.insufficient-balance-of")
            };
          }
        }
      });
      return checkObj;
    } else {
      // 计算不出来，金额输入有误
      return {
        check: false,
        msg: t("service.incorrect-amount-input")
      };
    }
  }
  checkDiscountData: any = {};
  // 提交收款
  async submitForm(checked = false, mobileCode) {
    if (!checked) {
      let checkResult = this.checkAmount();
      if (!checkResult.check) {
        this.$message.error(checkResult.msg);
        return;
      }
      if (this.subtractDiscounts.isUse && this.subtractDiscounts.disCountsValue) {
        const checkDiscount = await this.queryOtherDiscountCheckResult({
          orderNos: this.isMerge ? this.unpaidOrderList.map(item => item.orderNo) : [this.orderId],
          orderTotalAmount: String(this.totalOrderAmount),
          otherDiscountAmount: this.subtractDiscounts.disCountsValue
        });
        this.checkDiscountData = checkDiscount.data;
        if (checkDiscount.data.overLimitDiscount) {
          this.discountLimitDialogShow = true;
          return;
        }
      }
    }
    let params: any = {
      customerCode: this.detailData.customerCode,
      orderNos: this.isMerge ? this.unpaidOrderList.map(item => item.orderNo) : [this.orderId],
      paymentList: this.paymentWayList.filter(item => {
        return item.isUse;
      }),
      remark: this.remark,
      receiptAmount: this.actuallyAmount,
      selectedCards: this.getSelectedCardsData(),
      selectedCoupons: this.getSelectedCouponsData(),
      otherDiscountAmount: "",
      overLimitedVCode: mobileCode
    };
    if (this.subtractDiscounts.isUse) {
      params.otherDiscountAmount = this.subtractDiscounts.disCountsValue;
    }

    const deferredPayItem = params.paymentList.find(item => item.payMethodCode === "7");
    console.log(33, deferredPayItem);
    if (deferredPayItem && !deferredPayItem.billingCycle) {
      return this.$message.error("请选择账期");
    }
    this.btnStartLoading();
    this.orderPayment(params)
      .then(data => {
        if (data.data.validateInventoryAlert === "1") {
          if (this.isMerge || this.detailData.orderType !== "1") {
            const partsCodeList = this.totalPartsList.map(item => item.partsCode);
            if (partsCodeList && partsCodeList.length > 0) {
              this.queryInventoryAndNotice(partsCodeList);
            }
          }
        }
        if (this.onAccountTo) {
          // 挂账
          this.$router.push(
            `/service/settlement-success-credit?orderId=${this.orderId}&canLotteryLength=${
              data.data.campaignNameArray ? data.data.campaignNameArray.length : 0
            }`
          );
        } else {
          this.$router.push(
            `/service/settlement-success?orderId=${this.orderId}&canLotteryLength=${
              data.data.campaignNameArray ? data.data.campaignNameArray.length : 0
            }`
          );
        }
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  // 处理使用其他优惠
  handleUseSubtract(val) {
    if (!val) {
      this.cancelSubtractDiscount();
    }
    // 清空支付方式
    this.resetPaymentInput();
  }
  async handleUseCouponChange(val) {
    if (!val) {
      this.cancelUseCoupon();
      this.calculateOrder();
    }
    this.resetPaymentInput();
  }
  cancelUseCoupon() {
    this.checkCoupon.disCountsValue = "0";
    this.useableCouponList.forEach(coupon => {
      coupon.checked = false;
    });
  }

  handleCouponCheckChange() {
    // 清空支付方式
    this.resetPaymentInput();
    // 清空直减优惠
    this.cancelSubtractDiscount();
    // 接口计算订单
    this.calculateOrder();
  }
  cancelSubtractDiscount() {
    this.subtractDiscounts.disCountsValue = "";
  }
  totalOrderAmount = 0;
  getSelectedCardsData() {
    const selectedCardList = this.useableCardList.filter(item => item.cardSelected);
    const selectedCards = [];
    selectedCardList.forEach(card => {
      card.allCardItems.forEach(cardItem => {
        if (cardItem.checked) {
          selectedCards.push({
            discountCode: card.cardCode,
            discountPartsCode: cardItem.partsCode,
            discountServiceCode: cardItem.serviceCode,
            usedQuantity: cardItem.useNum
          });
        }
      });
    });
    return selectedCards;
  }
  getSelectedCouponsData() {
    return this.useableCouponList.filter(item => item.checked).map(item => item.couponCode);
  }
  calculateOrder() {
    const selectedCards = this.getSelectedCardsData();
    const selectedCoupons = this.getSelectedCouponsData();
    const params = {
      customerCode: this.detailData.customerCode,
      orderNos: this.isMerge ? this.unpaidOrderList.map(item => item.orderNo) : [this.orderId],
      selectedCards: selectedCards,
      selectedCoupons: selectedCoupons
    };
    this.calcCustomerOrder(params).then(data => {
      data.data.useableSetCards.forEach(card => {
        const codeResidueMap = {};
        card.allCardItems = [];
        if (card.selectedFlag === "1") {
          card.cardSelected = true;
        }
        if (card.serviceList) {
          card.serviceList.forEach(service => {
            if (!codeResidueMap[service.serviceCode]) {
              codeResidueMap[service.serviceCode] = Number(service.residueCount);
            } else {
              codeResidueMap[service.serviceCode] = codeResidueMap[service.serviceCode] + Number(service.residueCount);
            }
            if (service.selectedFlag === "1") {
              service.checked = true;
              service.useNum = Number(service.selectedCount);
            } else {
              service.checked = false;
              service.useNum = 0;
            }
            card.allCardItems.push(service);
          });
        }
        if (card.partsList) {
          card.partsList.forEach(parts => {
            if (!codeResidueMap[parts.partsCode]) {
              codeResidueMap[parts.partsCode] = Number(parts.residueCount);
            } else {
              codeResidueMap[parts.partsCode] = codeResidueMap[parts.partsCode] + Number(parts.residueCount);
            }
            if (parts.selectedFlag === "1") {
              parts.checked = true;
              parts.useNum = Number(parts.selectedCount);
            } else {
              parts.checked = false;
              parts.useNum = 0;
            }
            parts.isParts = true;
            card.allCardItems.push(parts);
          });
        }
        card.codeResidueMap = codeResidueMap;
      });

      this.useableCardList = data.data?.useableSetCards || [];
      this.computedCardDeduction();
      data.data.useableCoupons.forEach(coupon => {
        if (coupon.selectedFlag === "1") {
          coupon.checked = true;
        } else {
          coupon.checked = false;
        }
      });
      this.checkCoupon.disCountsValue = data.data.deductedAmountByCoupon || 0;
      this.packageDiscounts.disCountsValue = data.data.deductedAmountBySetCard || 0;
      this.useableCouponList = data.data?.useableCoupons || [];
      if (this.useableCouponList?.length === 0) {
        this.checkCoupon.isUse = false;
      }
      this.totalOrderAmount = Number(Number(data.data.orderAmount).toFixed(2));
    });
  }
  queryValueCardTotalBalance() {
    this.queryCustomerCard({
      cardType: "2",
      customerCode: this.detailData.customerCode
    }).then(data => {
      this.balance = Number(data.data?.balance || 0);
    });
  }
  handleRefreshCardCoupon() {
    this.calculateOrder();
  }
  discountLimitDialogShow = false;
  sendDiscountverificationCode() {
    return this.sendOtherDiscountValidationCode({
      orderNos: this.isMerge ? this.unpaidOrderList.map(item => item.orderNo) : [this.orderId],
      orderTotalAmount: String(this.totalOrderAmount),
      otherDiscountAmount: this.subtractDiscounts.disCountsValue
    });
  }
  overLimitedVCode = "";
  handleSettlement(mobileCode) {
    this.submitForm(true, mobileCode);
  }
  cycleList = [];
  getCycleList() {
    return this.queryDeferredCycleList().then(res => {
      this.cycleList = res?.data || [];
      this.paymentWayList.forEach(item => {
        item.billingCycle = this.cycleList?.[0] ? this.cycleList[0].billingCycleValue : "";
      });
    });
  }
  customerDeferredData: any = {};
  getCustomerDeferredData() {
    this.queryCustomerDeferredPayment({
      customerCode: this.detailData.customerCode
    }).then(res => {
      this.customerDeferredData = res.data;
    });
  }
  paymentWayDisabled(paymentWay) {
    if (paymentWay.payMethodCode === "6") {
      if (!this.balance) {
        return true;
      }
    } else if (paymentWay.payMethodCode === "7") {
      if (this.isMerge) {
        return true;
      }
    }
    return false;
  }
}
